import ScalarIconLink_vue_vue_type_script_setup_true_lang_default from "./ScalarIconLink.vue.script.js";
//#region src/components/ScalarIconLink.vue
var ScalarIconLink_default = ScalarIconLink_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconLink_default as default };

//# sourceMappingURL=ScalarIconLink.js.map